import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import CalendarContainer from "../../containers/CalendarContainer";
import PatientFinances from "../../containers/Patients/PatientFinances";
import { checkAuthenticated } from "../../actions/auth";
import "../../styles/detailPage.scss";
import EvolutionList from "../../containers/Patients/EvolutionList";
import CreatePatientModal from "../../containers/Modals/CreatePatientModal";
import {
  generar_ficha_paciente,
  load_patient_data_from_id,
} from "../../actions/clinic_content";
import PatientDocumentList from "../../containers/Patients/PatientDocumentList";
import { usePatientNavigation } from "../../hooks/useDetailNavigation";

const PatientDetailPage = () => {
  const dispatch = useDispatch();
  const { goToPatientFMS } = usePatientNavigation();
  const { pacienteId } = useParams();
  const [modalShow, setModalShow] = useState(false);
  const [infoCollapsed, setInfoCollapsed] = useState(true);
  const [patientData, setPatientData] = useState({
    id: pacienteId,
    rut: "",
    name: "",
    first_lastname: "",
    second_lastname: "",
    email: "",
    age: null,
    birthday: "",
    sex: "",
    address: "",
    phone: "",
    country: "",
    prevision: "",
    ocupation: "",
    health_info: {
      assigned_professional: "",
      professional_name: "",
      anamnesis: "",
      evaluation: "",
      objectives: "",

      diagnosis: "",
      medical_quote_date: "",
      doctors_name: "",
    },
  });

  const handleGenerarFicha = async () => {
    dispatch(checkAuthenticated());
    const data = await generar_ficha_paciente(pacienteId);
    if (data) {
      console.log(data);
      const url = `${process.env.REACT_APP_API_URL}${data.file}`;
      const link = document.createElement("a");
      link.href = url;
      const filename = url.substring(url.lastIndexOf("/") + 1);

      link.download = filename;
      link.target = "_blank";
      console.log(link);
      link.click();
    }
  };

  const fetchPatientData = async () => {
    dispatch(checkAuthenticated());

    await load_patient_data_from_id(pacienteId).then((data) => {
      setPatientData((prevData) => ({ ...prevData, ...data }));
    });
  };
  useEffect(() => {
    fetchPatientData();
  }, []);

  const goToDetail = (serviceId) => {
    console.log(serviceId);
  };
  return (
    <div className="content">
      <div className="d-flex justify-content-between align-items-center page-title">
        <h1>
          Detalle Paciente {patientData.name} {patientData.first_lastname}
        </h1>
        <div className="d-flex gap-2 mx-2 h-50">
          <Button
            variant="outline-secondary fw-bold d-flex align-items-center gap-2"
            onClick={handleGenerarFicha}
          >
            <i className="bi bi-printer" />
            Generar Ficha
          </Button>
          <Button
            variant="outline-danger fw-bold d-flex align-items-center gap-2"
            onClick={() => goToPatientFMS(pacienteId)}
          >
            <i className="bi bi-file-earmark-ruled" />
            Ficha FMS
          </Button>
          <Button
            variant="primary fw-bold d-flex align-items-center gap-2"
            onClick={() => setModalShow(true)}
          >
            <i className="bi bi-pencil-square"></i>Ver / Editar Datos
          </Button>
        </div>
      </div>
      <div className="personal-info-toggle">
        <Button
          variant="outline-secondary"
          onClick={() => setInfoCollapsed(!infoCollapsed)}
        >
          {infoCollapsed ? (
            <span>
              Ver Mas
              <i className="bi bi-arrow-down-square" />
            </span>
          ) : (
            <span>
              Ver Menos
              <i className="bi bi-arrow-up-square" />
            </span>
          )}
        </Button>
      </div>
      <div className={infoCollapsed ? "personal-info active" : "personal-info"}>
        <div className="p-3 d-flex align-items-center flex-column gap-1 info-section basic-info">
          <div className="section-title">
            <h2 className="text-center">{patientData.name}</h2>
          </div>
          <div className="d-flex align-items-center optional-info">
            <span>
              {patientData.name} {patientData.first_lastname}{" "}
              {patientData.second_lastname}
            </span>
          </div>
          <div className="d-flex flex-column align-items-center">
            <span>
              RUT:
              <strong className="px-2">{patientData.rut}</strong>
            </span>

            {/* <span>Registrado hace 7 meses</span> */}
          </div>
          <div className="info-field d-flex flex-row gap-2">
            <span>Email:</span>
            <strong>{patientData.email}</strong>
          </div>

          <div className="info-field d-flex flex-row gap-2">
            <span>Ingresado en:</span>
            <strong>{patientData.created}</strong>
          </div>
        </div>
        <div className="d-none d-lg-flex">
          <div className="vr"></div>
        </div>
        <div className="p-3 info-section general-info">
          <div className="section-title">
            <h5 className="text-center">Información</h5>
          </div>
          <div className="general-info-fields">
            <div className="two-col-field">
              <div className="col info-field">
                <span>Telefono</span>
                <strong>{patientData.phone}</strong>
              </div>
              <div className="info-field">
                <span>Previsión</span>
                <strong>{patientData.prevision}</strong>
              </div>
            </div>
            <div className="two-col-field">
              <div className="info-field">
                <span>Nacionalidad</span>
                <strong>{patientData.country}</strong>
              </div>
              <div className="col info-field">
                <span>Sexo</span>
                <strong>{patientData.sex}</strong>
              </div>
            </div>

            <div className="two-col-field optional-info">
              <div className="col info-field">
                <span>Nacimiento</span>
                <strong>{patientData.birthday}</strong>
              </div>
              {patientData.ocupation && (
                <div className="col info-field">
                  <span>Ocupación</span>
                  <strong>{patientData.ocupation}</strong>
                </div>
              )}
            </div>

            {patientData.ocupation && (
              <div className="info-field w-100 optional-info">
                <span>Domicilio</span>
                <strong>{patientData.address}</strong>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="calendar-app pb-4">
        <div className="d-flex justify-content-center">
          <h3>Agenda</h3>
        </div>
        <CalendarContainer patientId={pacienteId} />
      </div>
      <PatientFinances patientId={pacienteId} handleDetail={goToDetail} />
      <div className="ev-doc-lists">
        <EvolutionList patientId={pacienteId} />
        <div className="medic-data-section">
          {patientData.health_info && (
            <div className="info-section">
              <div className="section-title">
                <h5 className="text-center">Datos Medicos</h5>
              </div>
              <div className="general-info-fields">
                <div className="info-field ">
                  <span>Kinesiologo Asignado:</span>
                  <strong>
                    {patientData.health_info.professional_name
                      ? patientData.health_info.professional_name
                      : "N/A"}
                  </strong>
                </div>
                <div className="two-col-field flex-nowrap">
                  <div className="info-field">
                    <span>Fecha atención Medica:</span>
                    <strong>
                      {patientData.health_info.medical_quote_date
                        ? patientData.health_info.medical_quote_date
                        : "N/A"}
                    </strong>
                  </div>
                  <div className="info-field">
                    <span>Medico:</span>
                    <strong>
                      {patientData.health_info.doctors_name
                        ? patientData.health_info.doctors_name
                        : "N/A"}
                    </strong>
                  </div>
                </div>
                <div className="info-field w-100">
                  <span>Diagnostico:</span>
                  <strong>
                    {patientData.health_info.diagnosis
                      ? patientData.health_info.diagnosis
                      : "N/A"}
                  </strong>
                </div>
                <div className="info-field w-100">
                  <span>Anamnesis:</span>
                  <strong>
                    {patientData.health_info.anamnesis
                      ? patientData.health_info.anamnesis
                      : "N/A"}
                  </strong>
                </div>
                <div className="info-field w-100">
                  <span>Evaluacion:</span>
                  <strong>
                    {patientData.health_info.evaluation
                      ? patientData.health_info.evaluation
                      : "N/A"}
                  </strong>
                </div>
                <div className="info-field w-100">
                  <span>Objetivos:</span>
                  <strong>
                    {patientData.health_info.objectives
                      ? patientData.health_info.objectives
                      : "N/A"}
                  </strong>
                </div>
              </div>
            </div>
          )}
          <PatientDocumentList pacienteId={pacienteId} />
        </div>
      </div>
      {patientData.rut && (
        <CreatePatientModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          patientId={pacienteId}
          loadedPatientData={patientData}
        />
      )}
    </div>
  );
};

export default PatientDetailPage;
